/**
 * Base URL for objects in `com.lqa.v5.images`. Uses {@link Env.CLOUDFRONT_MEDIA_URL} when set, else legacy S3.
 */
const LEGACY_PUBLIC_IMAGES_PREFIX = 'https://s3.amazonaws.com/com.lqa.v5.images.dev';

/**
 * Pure URL builder; {@link publicStaticMediaUrl} passes `Env.CLOUDFRONT_MEDIA_URL` as `cdnBase`.
 */
export function buildPublicStaticMediaUrl (objectKey: string, cdnBase: string | undefined | null): string {
  const key = objectKey.replace(/^\/+/, '');
  const raw = cdnBase != null && String(cdnBase).trim() !== '' ? String(cdnBase).trim() : '';
  const base = raw.replace(/\/+$/, '');
  if (base) {
    return `${base}/${key}`;
  }
  return `${LEGACY_PUBLIC_IMAGES_PREFIX}/${key}`;
}

export function publicStaticMediaUrl (objectKey: string): string {
  const raw = typeof Env !== 'undefined' && Env.CLOUDFRONT_MEDIA_URL ? String(Env.CLOUDFRONT_MEDIA_URL).trim() : '';
  return buildPublicStaticMediaUrl(objectKey, raw || null);
}
